import { getUser, useBreakpoints, useInstance } from '@10000/react'
import { Body, Box, Button, Google, H3, H4 } from '../widgets'
import { InputScreen, signUpBackground, useBackground, useShell, useStack } from '../layout'
import { assetUrl } from '../../utilities.js'
import { AccountVerification } from './'
import { authRedirectUri, createAccount, signUp, country as getCountry } from './request.js'
import { CountryDropDown, Submit, Text } from '../forms'
import { Authenticate } from './'

export const SignUp = ({ active, free, external }) => {
  const { replaceStack } = useStack()
  const { mobile } = useBreakpoints()
  const { setInstance } = useInstance()

  useBackground().set(mobile => ({ active, fade: free, ...signUpBackground(mobile, true, false, free) }))
  useShell({ active, mode: free ? 'navigate' : 'navigate narrow' })

  const handleSignUp = ({ name, email, country }) => external
    ? getCountry(country)
        .then(({ region }) => createAccount({ region, country, refreshToken: user.refreshToken, free })
          .then(({ user: { tenantId } }) => setInstance({ id: tenantId, region }))
        )
    : signUp(email, country, name, 0, free)
        .then(({ region }) => {
          window.history.replaceState({}, '', window.location.pathname) // remove ?free parameter
          replaceStack(AccountVerification, { props: { email, region, free } })
        })

  const user = getUser()
  const initialValues = external && {
    email: user?.data.email,
    name: user?.data.name
  }

  return (
    <InputScreen
      fade={!free}
      title={free
        ? <Box column alignItems="center" gap={24}>
            <H3>Welcome to Shivoo</H3>
            <H4>See what&apos;s possible<br/>with our demo</H4>
          </Box>
        : 'Create your account'}
      formValues={initialValues}
      onSubmit={handleSignUp}
      centered={free}
      gap={32}
    >
      {(!mobile && !free) &&
        <video src={assetUrl('videos/create-account.mp4')} autoPlay muted playsInline loop style={{ width: 150 }} />
      }

      <Box fullWidth gap={8} column grow={external} alignItems="center">
        <Text
          title="Name"
          name="name"
          required
        />
        <Text
          title="Email"
          name="email"
          type="email"
          required
          disabled={external}
        />
        <CountryDropDown
          name="country"
          fullWidth
          search
        />
      </Box>

      <Box column fullWidth alignItems="center" pb={16} gap={16}>
        {external
          ? <Submit fullWidth>
              Next
            </Submit>
          : <>
              <Submit fullWidth>
                Sign up
              </Submit>

              <Box fullWidth alignItems="center" justifyContent="space-between">
                <Box width="40%" height={1} background="white" />
                <Body>or</Body>
                <Box width="40%" height={1} background="white" />
              </Box>

              <Box gap={8} fullWidth>
                <Button
                  fullWidth
                  onClick={() => window.location.href = authRedirectUri('AP', 'Google', free && { free: true })}
                >
                  <Google />
                </Button>
              </Box>

              {!free &&
                <Box gap={4} alignItems="center">
                  <Body>
                    Already have an account?
                  </Body>
                  <a onClick={() => replaceStack(Authenticate)}>Log in</a>
                </Box>
              }
            </>
        }
      </Box>
    </InputScreen>
  )
}